import {Box, Typography} from "@mui/material";
import {connect} from "react-redux";
import {selectModeData} from "../../../redux/selectors/editor";
import {IGraphData} from "../../../redux/slices/editor";
import {ReactElement} from "react";
import SelectedDetails from "./SelectedDetails";

interface IProps {
    graphData: IGraphData
}
function SelectedInspector({graphData}: IProps) {
    let contents: ReactElement | null = null;

    if (graphData.selected === undefined || graphData.selected.length === 0) {
        contents = <Typography variant="body1">Select node to see details</Typography>
    } else {
        contents = <SelectedDetails states={graphData.selected}/>
    }
    return (
        <Box>
            {contents}
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    graphData: selectModeData(store) as IGraphData,
});

export default connect(mapStateToProps, {
})(SelectedInspector);
